<script setup lang="ts">
import { computed, onMounted, ref } from "vue";

const props = defineProps({
  src: {
    type: String,
    required: false,
    default: null,
  },
  srcLoading: {
    type: String,
    required: false,
    default: null,
  },
  src404: {
    type: String,
    required: false,
    default: "/images/imagen-no-disponible.png",
  },
  width: {
    type: String,
    default: undefined,
  },
  height: {
    type: String,
    default: undefined,
  },
});
const loading = ref(false);
const error = ref(false);

const success = computed(() => !loading.value && !error.value);
const fixedSrc = computed(() => {
  let src: string | undefined;
  if (loading.value) {
    src = props.srcLoading;
  } else if (error.value) {
    src = props.src404;
  } else {
    src = props.src;
  }
  if (!src) {
    src = props.src;
  }
  return src;
});

onMounted(() => {
  if (props.src) {
    const image = document.createElement("img");
    image.src = props.src;
    const finish = (success: boolean) => {
      loading.value = false;
      error.value = !success;
    };
    image.addEventListener("load", () => finish(true));
    image.addEventListener("error", () => finish(false));
  }
});
</script>
<template>
  <div v-if="loading && !srcLoading" class="placeholder-glow">
    <span class="placeholder w-100 h-100"></span>
  </div>
  <img v-else-if="success" :src="fixedSrc" :width="width" :height="height" />
  <!-- HTML custom de 404 si se pasa por Slot. -->
  <slot v-else-if="$slots.default" name="default" />
</template>
